/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_03_Detail_Amateur_1_HeadingInputs */

const en_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What actually happens after contact`)
};

const es_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué ocurre realmente después del contacto`)
};

const de_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was passiert eigentlich nach dem Kontakt?`)
};

const zh_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`触球之后真正发生了什么`)
};

const ar_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما يحدث فعلياً بعد التماس`)
};

const fr_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que se passe-t-il réellement après le contact`)
};

const vi_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều thực sự xảy ra sau tiếp xúc`)
};

const sw_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinachotokea kweli baada ya mguso`)
};

const th_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิ่งที่เกิดขึ้นจริงหลังการปะทะลูก`)
};

const bs_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šta se zapravo dešava poslije kontakta`)
};

const ja_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンタクトのあとに実際に起きていること`)
};

const ko_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`콘택트 뒤에 실제로 일어나는 일`)
};

const pt_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que realmente acontece depois do contato`)
};

const it_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che cosa succede davvero dopo il contatto`)
};

const sv_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad som faktiskt händer efter träffen`)
};

const nl_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat er echt gebeurt na het contact`)
};

const da_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad der faktisk sker efter kontakten`)
};

const nb_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hva som faktisk skjer etter treffet`)
};

const fi_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitä osuman jälkeen oikeasti tapahtuu`)
};

const pl_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co naprawdę dzieje się po kontakcie`)
};

const ru_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что на самом деле происходит после контакта`)
};

const tr_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temastan sonra gerçekte ne olur`)
};

const hi_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपर्क के बाद असल में क्या होता है`)
};

const id_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang sebenarnya terjadi setelah kontak`)
};

const ms_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang sebenarnya berlaku selepas sentuhan`)
};

const cs_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co se po kontaktu skutečně děje`)
};

const el_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τι πραγματικά συμβαίνει μετά την επαφή`)
};

const he_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מה באמת קורה אחרי המגע`)
};

const af_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat werklik ná kontak gebeur`)
};

const hu_method_content_step_03_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi történik valójában az érintkezés után`)
};

/**
* | output |
* | --- |
* | "What actually happens after contact" |
*
* @param {Method_Content_Step_03_Detail_Amateur_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_03_detail_amateur_1_heading = /** @type {((inputs?: Method_Content_Step_03_Detail_Amateur_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_03_Detail_Amateur_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "de") return de_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "th") return th_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "it") return it_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "da") return da_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "id") return id_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "el") return el_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "he") return he_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "af") return af_method_content_step_03_detail_amateur_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_03_detail_amateur_1_heading(inputs)
	return en_method_content_step_03_detail_amateur_1_heading(inputs)
});